<template lang="html">

    <section class="accesos">

      <article class="acceso row-center -practicas-internas">
        <h2 class="titulo">Programa de Prácticas Internas</h2>
        <router-link class="enlace-cover" :to="$t('enlaces.ofertas')+'/practicas-internas'"></router-link>
      </article>
      <article class="acceso row-center -orientacion">
        <h2 class="titulo">Orientación</h2>
        <router-link class="enlace-cover" :to="$t('enlaces.orientacionprofesional')"></router-link>
      </article>
      <article class="acceso row-center -internacional">
        <h2 class="titulo">Internacional</h2>
        <router-link class="enlace-cover" :to="$t('enlaces.internacional')"></router-link>
      </article>
      <article class="acceso row-center -estudia-trabaja">
        <h2 class="titulo">Programa estudia y trabaja</h2>
        <router-link class="enlace-cover" :to="$t('enlaces.estudiaytrabaja')"></router-link>
      </article>
      
    </section>
  
  </template>
  
  <script lang="js">
    export default  {
      name: 'accesos-home',
  }
  </script>
  
  <style scoped lang="scss">
  </style>


// WEBPACK FOOTER //
// src/components/view-parts/home/accesos.vue